( () => {
	const BLOCK_CLASS = 'wp-block-phrase-com-video-cover';
	const blocks = document.querySelectorAll< HTMLDivElement >( `.${ BLOCK_CLASS }` );
	if ( ! blocks.length ) {
		return;
	}

	const useVideo = window.matchMedia( '(min-width: 768px)' ).matches;

	blocks.forEach( ( block ) => {
		const media = block.dataset.media || '[]';
		const videos = JSON.parse( media );
		if ( ! videos.length ) {
			return;
		}

		const videoData = videos[ Math.floor( Math.random() * videos.length ) ];

		if ( useVideo && videoData.videoUrl ) {
			const video = document.createElement( 'video' );
			video.src = videoData.videoUrl;
			video.loop = true;
			video.autoplay = true;
			video.muted = true;
			video.playsInline = true;
			video.preload = 'metadata';
			video.className = `${ BLOCK_CLASS }__video`;
			video.onloadeddata = function () {
				video.classList.add( 'animate' );
			};

			block.insertBefore( video, block.firstChild );
		} else if ( videoData.imageUrl ) {
			const image = document.createElement( 'img' );
			image.src = videoData.imageUrl;
			image.alt = '';
			image.className = `${ BLOCK_CLASS }__image`;
			image.onload = function () {
				image.classList.add( 'animate' );
			};

			block.insertBefore( image, block.firstChild );
		}
	} );
} )();
